import { Divider, Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { ExamDateDto } from "api";
import { Header, SuccessHeaderIcon } from "components";

export const ConfirmationSuccessPayment = ({
  examDetails,
}: {
  examDetails?: ExamDateDto;
}) => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ gap: 2 }}>
      <Header
        title={t("confirmation.success.title")}
        subtitle={t("confirmation.success.subtitle")}
        icon={<SuccessHeaderIcon />}
      />

      <Typography>
        <Trans
          i18nKey="confirmation.registrationComplete"
          values={{ examName: examDetails?.examName }}
          components={{ bold: <strong /> }}
        />
      </Typography>
      <Typography>
        <Trans
          i18nKey="confirmation.examScheduleNotice"
          components={{ bold: <strong /> }}
        />
      </Typography>
      <Typography>{t("confirmation.oralExamNote")}</Typography>
      <Divider />
      <Typography>{t("confirmation.thankYou")}</Typography>
    </Stack>
  );
};
